import { Injectable } from '@angular/core';
import { IAppState } from '../types/infrastructure/interfaces/IAppState';
import { IAuthInfo } from '../types/IAuthInfo';
import { IUserInfo } from '../types/IUserinfo';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor() {}

  getAppState(): IAppState | null {
    var state = localStorage.getItem('Budgetantragstool.AppState');
    if (state) {
      return JSON.parse(state);
    }
    return null;
  }

  setAppState(appState: IAppState) {
    localStorage.setItem('Budgetantragstool.AppState', JSON.stringify(appState));
   // console.log(appState);
  }

  getAuthentification(): IAuthInfo | null {
    var state = localStorage.getItem('Budgetantragstool.Authentification');
    if (state) {
      return JSON.parse(state);
    }
    return null;
  }

  setAuthentification(appState: IAuthInfo) {
    localStorage.setItem('Budgetantragstool.Authentification', JSON.stringify(appState));
  }

  clearAuthentification() {
    localStorage.removeItem('Budgetantragstool.Authentification');
  }
 
  getUserInfo(): IUserInfo | null {
    var state = localStorage.getItem('Budgetantragstool.UserInfo');
    if (state) {
      return JSON.parse(state);
    }
    return null;
  }

  setUserInfo(appState: IUserInfo) {
    localStorage.setItem('Budgetantragstool.UserInfo', JSON.stringify(appState));
  }

  // Set a value in local storage
  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  // Get a value from local storage
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  // Remove a value from local storage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items from local storage
  clear(): void {
    localStorage.clear();
  }
}